import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import SubmissionStatusBadge from "./SubmissionStatusBadge";
import Button from "../../common/Button";
import AwesomeIcon from "../../AwesomeIcon";
import { faEllipsisVertical, faTrashCan, faRefresh } from "@fortawesome/pro-regular-svg-icons";
import useSubmissionPolling from "../services/useSubmissionPolling";
import Toast from "../../Toast";
import { SUBMISSION_STATUS, ACR_STATUS } from "../../../constants/acr";
import { getReportDisplayTitle, isPollableStatus } from "../../../utils/acrUtils";
import { useTranslation } from "react-i18next";
import { format, parseISO } from "date-fns";
var DELETABLE_STATUSES = [SUBMISSION_STATUS.PENDING, SUBMISSION_STATUS.READY, SUBMISSION_STATUS.VALIDATION_FAILED, SUBMISSION_STATUS.ERROR];
var ReportCard = function ReportCard(_ref) {
  var _submission$status;
  var report = _ref.report,
    workspaceId = _ref.workspaceId,
    patientId = _ref.patientId,
    onViewDetails = _ref.onViewDetails,
    onCreateSubmission = _ref.onCreateSubmission,
    onDeleteSubmission = _ref.onDeleteSubmission,
    isCreating = _ref.isCreating;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasSubmission = report.acr_submission !== null;
  var submission = report.acr_submission;
  var _useState = useState(false),
    menuOpen = _useState[0],
    setMenuOpen = _useState[1];
  var menuRef = useRef(null);
  var statusLower = (submission === null || submission === void 0 || (_submission$status = submission.status) === null || _submission$status === void 0 ? void 0 : _submission$status.toLowerCase()) || "";
  var acrStatus = (submission === null || submission === void 0 ? void 0 : submission.acr_status) || "";
  var isDeletable = DELETABLE_STATUSES.includes(statusLower) || acrStatus && [ACR_STATUS.PARTIALLY_SUCCESSFUL, ACR_STATUS.VALIDATION_FAIL, ACR_STATUS.FAILED].includes(acrStatus);
  var isStatusPollable = isPollableStatus(acrStatus, (submission === null || submission === void 0 ? void 0 : submission.status) || "");

  // Manual polling (user-initiated via refresh button)
  var _useSubmissionPolling = useSubmissionPolling({
      submissionId: (submission === null || submission === void 0 ? void 0 : submission.id) || 0,
      workspaceId: workspaceId
    }),
    poll = _useSubmissionPolling.poll,
    isLoading = _useSubmissionPolling.isLoading;
  var studyDescription = getReportDisplayTitle(report);
  var examDate = report !== null && report !== void 0 && report.updated_at ? format(parseISO(report === null || report === void 0 ? void 0 : report.updated_at), "MM/dd/yyyy, h:mma") : null;
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return function () {
      return document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);
  var handleCardClick = function handleCardClick() {
    if (hasSubmission && submission) {
      onViewDetails(submission.id);
    }
  };
  var handleRefresh = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var _result$status, result, _error$response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            e.stopPropagation();
            _context.p = 1;
            _context.n = 2;
            return poll();
          case 2:
            result = _context.v;
            // Don't show success toast for validation failures - already shown by polling hook
            if ((result === null || result === void 0 || (_result$status = result.status) === null || _result$status === void 0 ? void 0 : _result$status.toLowerCase()) !== "validation_failed") {
              Toast.success("Status refreshed successfully");
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            Toast.error((_t === null || _t === void 0 || (_error$response = _t.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.detail) || "Failed to refresh submission status");
          case 4:
            setMenuOpen(false);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleRefresh(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleDelete = function handleDelete(e) {
    e.stopPropagation();
    onDeleteSubmission(submission.id);
    setMenuOpen(false);
  };
  if (!hasSubmission) {
    return /*#__PURE__*/React.createElement("div", {
      className: "group rounded-lg px-4 py-3 border border-dashed border-gray-400 dark:border-gray-600 bg-gray-200/30 dark:bg-gray-800/20 hover:border-gray-500 dark:hover:border-gray-500 hover:bg-gray-300/40 dark:hover:bg-gray-800/30 transition-colors"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-start justify-between gap-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-start min-w-0 text-left"
    }, /*#__PURE__*/React.createElement("span", {
      title: studyDescription,
      className: "text-base font-semibold truncate max-w-full text-gray-800 dark:text-gray-200"
    }, studyDescription)), /*#__PURE__*/React.createElement(Button, {
      className: "h-7 text-sm shrink-0",
      onClick: function onClick() {
        return onCreateSubmission(report.report_id);
      },
      disabled: isCreating
    }, isCreating ? t("button.creating") : t("button.add_submission"))));
  }
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleCardClick,
    className: "group relative rounded-lg px-4 py-3 bg-gray-200/50 dark:bg-gray-800/50 hover:bg-gray-300/60 dark:hover:bg-gray-700/60 border border-gray-300 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-600 cursor-pointer transition-colors"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start min-w-0 flex-1 text-left"
  }, /*#__PURE__*/React.createElement("span", {
    title: studyDescription,
    className: "text-base text-gray-800 dark:text-gray-200 font-semibold truncate max-w-full"
  }, studyDescription), (submission === null || submission === void 0 ? void 0 : submission.acr_transaction_id) && /*#__PURE__*/React.createElement("span", {
    className: "text-sm text-gray-600 dark:text-gray-500 truncate max-w-full"
  }, submission.acr_transaction_id), examDate && /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-600 dark:text-gray-500 text-left"
  }, examDate), (submission === null || submission === void 0 ? void 0 : submission.populated_at) && /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-cyan-600 dark:text-cyan-500 text-left"
  }, t("label.populated"), ": ", new Date(submission.populated_at).toLocaleString())), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end justify-between gap-2 shrink-0 self-stretch"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-2"
  }, /*#__PURE__*/React.createElement(SubmissionStatusBadge, {
    status: submission.status,
    acrStatus: submission.acr_status,
    validationErrors: submission.acr_validation_errors
  })), isStatusPollable && /*#__PURE__*/React.createElement("button", {
    onClick: handleRefresh,
    disabled: isLoading,
    className: "flex items-center gap-1.5 px-3 py-1 rounded-full text-md text-teal-600 dark:text-teal-400 border border-teal-600/40 dark:border-teal-400/40 hover:bg-teal-600/10 dark:hover:bg-teal-400/10 transition-colors cursor-pointer disabled:opacity-50",
    title: t("label.acr.check_submission_status")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faRefresh,
    size: "sm",
    className: classNames({
      "animate-spin": isLoading
    })
  }), /*#__PURE__*/React.createElement("span", null, isLoading ? t("button.checking") : t("button.check_status"))))), isDeletable && /*#__PURE__*/React.createElement("div", {
    ref: menuRef,
    className: "absolute right-1 top-1/2 transform-none -translate-y-1/2"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      setMenuOpen(!menuOpen);
    },
    className: "p-1.5 rounded bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 shadow-sm hover:bg-gray-100 dark:hover:bg-gray-600 opacity-0 group-hover:opacity-100 transition-all cursor-pointer"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faEllipsisVertical,
    size: "1x",
    className: "text-gray-600 dark:text-gray-400"
  })), menuOpen && /*#__PURE__*/React.createElement("div", {
    className: "absolute right-[18px] top-[16px] bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-xl z-10 min-w-[120px] overflow-hidden"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleDelete,
    className: "w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 dark:text-red-400 bg-white dark:bg-gray-800 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors cursor-pointer"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTrashCan,
    size: "sm"
  }), /*#__PURE__*/React.createElement("span", null, t("button.delete"))))));
};
export default ReportCard;